/**
 * User-level call permissions default to allowed when the flag is absent (legacy payloads).
 * Call permissions are independent from chat permissions (e.g. view_all_chats).
 */
export const canUserReceiveCalls = (retailerUser) => retailerUser?.can_receive_calls ?? true;

export const canUserMakeCalls = (retailerUser) => retailerUser?.can_make_calls ?? true;

export const canUserViewAllCalls = (retailerUser) => retailerUser?.can_view_all_calls ?? false;

export const canUserViewLiveCalls = (retailerUser) => retailerUser?.can_view_live_calls ?? false;

/**
 * Whether the user may manage the calls integration (connect voice SIP).
 * Fuente de verdad única: el flag `has_superior_permissions` del agent_serializer
 * (= `RetailerUser#has_superior_permissions?`, admin/supervisor por permisos del
 * rol, nuevo sistema de permisos). Coincide con el backend `can_register_sip?`.
 */
export const canUserManageCalls = (retailerUser) => Boolean(retailerUser?.has_superior_permissions);

const normalizeAgentId = (value) => {
  if (value == null || value === '') return null;
  return String(value);
};

/**
 * Whether the current user may see/answer an incoming call for a customer assignment.
 * Uses only call receive permission + agent assignment — not chat visibility (view_all_chats).
 * - Assigned customer: only the assigned agent (with receive_calls) may receive it.
 * - Unassigned customer: any user with receive_calls may receive it.
 * view_all_calls controls call history visibility, not incoming ringing.
 */
export const canUserReceiveIncomingCallForAssignment = (retailerUser, assignedAgentId) => {
  if (!canUserReceiveCalls(retailerUser)) return false;

  const normalizedAssignedAgentId = normalizeAgentId(assignedAgentId);
  if (!normalizedAssignedAgentId) return true;

  return normalizedAssignedAgentId === normalizeAgentId(retailerUser?.id);
};
